/* ============================================================================
   ELARIQ - theme.js
   Site-wide behaviour. No dependencies, no build step.

   Ported from the static build's site.js, with three deliberate differences:
     - the cart is REAL. The prototype faked a line item from the selected tier;
       here every mutation goes through Shopify's /cart .js API and the drawer
       renders whatever the cart actually contains.
     - the countdown bar is gone. Elariq's positioning rules out scarcity
       timers, and the announcement carries standing terms instead.
     - the purchase toasts are gone. They fabricated named buyers.
   ============================================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    return (window.Shopify && window.Shopify.formatMoney)
      ? window.Shopify.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  };
  // The cart drawer builds its lines as innerHTML, so anything that came back
  // from the cart API is escaped before it goes in.
  var esc = function (s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };

  /* ---- announcement rotator ------------------------------------------- */
  $$('[data-announce]').forEach(function (bar) {
    var slides = $$('[data-announce-slide]', bar);
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, parseInt(bar.dataset.announce, 10) || 5000);
  });

  /* ---- mobile drawer --------------------------------------------------- */
  (function () {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    var opener = $('[data-drawer-open]');
    function show() {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function hide() {
      drawer.hidden = true;
      document.body.style.overflow = '';
      if (opener) opener.setAttribute('aria-expanded', 'false');
    }
    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', show); });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', hide); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) hide(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) hide();
    });
  })();

  /* ---- sticky buy bar: appears once the hero is past ------------------- */
  (function () {
    var bar = $('[data-stickybuy]');
    if (!bar) return;
    var anchor = $('[data-hero]') || $('main');
    if (!anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(anchor);
  })();

  /* ---- sticky buy bar: the bundle ladder -------------------------------- */
  /* The bar adds to the cart directly, so it carries the same two things the
     buy box carries: the price of the tier you are looking at, and the gifts
     that tier unlocks as a line item property. Without the second one the bar
     would promise a gift on screen and add a line that never mentions it. */
  (function () {
    var bar = $('[data-stickybuy]');
    if (!bar) return;
    var tiers = $$('[data-sb-tier]', bar);
    if (!tiers.length) return;
    var price = $('[data-sb-price]', bar);
    var gift = $('[data-sb-gift]', bar);

    function sync() {
      var on = tiers.filter(function (t) { return t.checked; })[0];
      if (!on) return;
      if (price && on.dataset.price) price.textContent = on.dataset.price;
      if (gift) gift.value = on.dataset.gift || '';
      $$('.sbtier', bar).forEach(function (l) {
        l.classList.toggle('is-on', l.contains(on));
      });
    }
    tiers.forEach(function (t) { t.addEventListener('change', sync); });
    sync();
  })();

  /* ---- scroll reveal ---------------------------------------------------- */
  (function () {
    var targets = $$('[data-reveal]');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.15 });
    targets.forEach(function (t) { io.observe(t); });
  })();

  /* ---- cart ------------------------------------------------------------- *
     One source of truth: fetch the cart, render it, update every count. The
     prototype drew a line item from whatever tier was selected on the page,
     which meant the drawer could disagree with the cart it was supposed to be
     showing.                                                                */
  var Cart = window.ElariqCart = (function () {
    var drawer = $('[data-cart]');
    var threshold = parseInt((document.body.dataset.shipThreshold || '0'), 10);

    function open() {
      if (!drawer) return;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = $('[data-cart-close]', drawer);
      if (close) close.focus();
    }
    function close() {
      if (!drawer) return;
      drawer.hidden = true;
      document.body.style.overflow = '';
    }

    function renderProgress(total) {
      var wrap = $('[data-cart-progress]');
      if (!wrap || !threshold) return;
      var pct = Math.min(100, Math.round(total / threshold * 100));
      var bar = $('[data-cart-progress-bar]', wrap);
      var msg = $('[data-cart-progress-msg]', wrap);
      if (bar) bar.style.width = pct + '%';
      if (!msg) return;
      if (total >= threshold) {
        msg.textContent = wrap.dataset.metMessage || '';
      } else {
        msg.textContent = (wrap.dataset.message || '').replace('[[amount]]', money(threshold - total));
      }
    }

    function render(cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
      renderProgress(cart.total_price);

      var list = $('[data-cart-items]');
      if (!list) return;
      var empty = $('[data-cart-empty]');
      if (empty) empty.hidden = cart.item_count > 0;
      var foot = $('[data-cart-foot]');
      if (foot) foot.hidden = cart.item_count === 0;

      list.innerHTML = cart.items.map(function (item) {
        // Size with the width parameter, not the old _160x filename infix.
        // The infix form is legacy and does nothing to a modern cdn.shopify.com
        // URL that already carries a query string, so every line item rendered
        // a broken image.
        var img = item.image
          ? '<img class="cartline__img" src="' + item.image.split('?')[0] + '?width=160" alt="" width="64" height="64" loading="lazy">'
          : '<span class="cartline__img" aria-hidden="true"></span>';
        var plan = item.selling_plan_allocation
          ? '<span class="cartline__meta">' + item.selling_plan_allocation.selling_plan.name + '</span>'
          : (item.variant_title && item.variant_title !== 'Default Title'
              ? '<span class="cartline__meta">' + item.variant_title + '</span>' : '');
        // Line item properties, which is where the unlocked gifts live. Without
        // this the drawer showed one anonymous line and the shopper had no
        // confirmation that the travel case and the mystery gift came with it.
        // Shopify's own convention: keys starting "_" are private, so they are
        // not rendered. Values are escaped because they end up as innerHTML.
        var props = '';
        if (item.properties) {
          props = Object.keys(item.properties).filter(function (k) {
            return k.charAt(0) !== '_' && String(item.properties[k]).trim();
          }).map(function (k) {
            return '<span class="cartline__gift"><b>' + esc(k) + ':</b> ' + esc(item.properties[k]) + '</span>';
          }).join('');
        }
        return '<div class="cartline" data-line="' + item.key + '">' + img +
          '<div class="cartline__body">' +
            '<span class="cartline__name">' + item.product_title + '</span>' + plan + props +
            '<div class="cartline__qty">' +
              '<button type="button" class="cartline__step" data-line-minus aria-label="Reduce quantity">&minus;</button>' +
              '<span data-line-qty>' + item.quantity + '</span>' +
              '<button type="button" class="cartline__step" data-line-plus aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<span class="cartline__price">' + money(item.final_line_price) + '</span>' +
        '</div>';
      }).join('');
    }

    function get() {
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); return cart; });
    }

    function change(body) {
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); return cart; });
    }

    function add(payload) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      }).then(function () { return get(); }).then(function (cart) { open(); return cart; });
    }

    if (drawer) {
      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); get().then(open); });
      });
      $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
      drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !drawer.hidden) close();
      });
      drawer.addEventListener('click', function (e) {
        var line = e.target.closest('[data-line]');
        if (!line) return;
        var qty = parseInt($('[data-line-qty]', line).textContent, 10);
        if (e.target.closest('[data-line-plus]')) change({ id: line.dataset.line, quantity: qty + 1 });
        if (e.target.closest('[data-line-minus]')) change({ id: line.dataset.line, quantity: qty - 1 });
      });
      get();
    }

    return { open: open, close: close, add: add, get: get, render: render };
  })();

  /* ---- add-to-cart forms ------------------------------------------------ */
  $$('form[data-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var error = form.querySelector('[data-atc-error]');
      if (error) { error.hidden = true; error.textContent = ''; }
      if (button) { button.disabled = true; button.classList.add('is-busy'); }

      var data = new FormData(form);
      var payload = { items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }] };
      if (data.get('selling_plan')) payload.items[0].selling_plan = Number(data.get('selling_plan'));

      // Line item properties, e.g. the gifts the chosen tier unlocks. The
      // payload is hand-built rather than posted as form data, so anything named
      // properties[...] has to be lifted across explicitly or it is silently
      // dropped and the cart never hears about the gifts. Empty values are
      // skipped: Shopify would otherwise record a property with a blank value
      // and every line would carry an empty row.
      data.forEach(function (value, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (!m || !String(value).trim()) return;
        payload.items[0].properties = payload.items[0].properties || {};
        payload.items[0].properties[m[1]] = String(value).trim();
      });

      Cart.add(payload)
        .catch(function (err) {
          if (!error) return;
          error.textContent = err.message;
          error.hidden = false;
        })
        .then(function () {
          if (button) { button.disabled = false; button.classList.remove('is-busy'); }
        });
    });
  });

  /* ---- accordions ------------------------------------------------------- */
  $$('[data-accordion] > details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      var group = d.parentElement;
      if (group.dataset.accordion !== 'single') return;
      $$('details[open]', group).forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
})();
